import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import HeaderStyled from '../HeaderStyled';
import { rem } from 'polished';
import media from '../../../styles/media';

export const HeaderStyledAC = styled(HeaderStyled)`
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.black};
    padding: 0 ${rem(14)} 0 ${rem(2)};

    @media (min-width: ${breakpoints.xs}px) {
        padding: 0 ${rem('28px')};
    }

    &.withMobileBorder {
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey3};

        @media (min-width: ${breakpoints.md}px) {
            border-bottom: unset;
        }
    }

    .switch-vertical > .toggle-outside > .toggle-inside {
        &:focus-visible {
            outline: 3px solid ${({ theme }) => theme.colors.black} !important;
            background: ${({ theme }) => theme.colors.blue2};
        }
    }

    .header-container {
        padding-left: 0;
        padding-right: 0;
        height: ${rem('112px')};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        .skip-content > a {
            color: ${({ theme }) => theme.colors.white};
            background: ${({ theme }) => theme.colors.blue2};
            border-radius: ${rem(24)};
            font-size: ${({ theme }) => theme.fontSizes.h4};
            font-family: ${({ theme }) => theme.fonts.fontBase};
        }

        > * {
            flex-grow: 1;
            flex-basis: 0;
        }

        .logo > div {
            display: flex;
            justify-content: center;
            flex-direction: column;

            svg {
                height: ${rem('50px')};
                width: ${rem('50px')};

                ${media.xs`
                    height: 80px;
                    width: 79px;
                `}
            }
        }

        @media (max-width: ${breakpoints.xs}px) {
            height: ${rem('68px')};
        }
    }

    .title-section {
        padding: 0;

        .title-primary {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            letter-spacing: 0;

            p {
                margin: 0 0 ${rem(4)} 0;
            }

            .title-container {
                @media (min-width: ${breakpoints.xs}px) {
                    display: none;
                }
            }
        }

        .title-secondary {
            font-size: ${rem(10)};
            margin: 0;
            text-transform: capitalize;
        }
    }

    .main-section {
        min-width: ${rem('105px')};

        @media (max-width: ${breakpoints.xs}px) {
            flex-grow: 2;
        }
    }

    .main-section .logo {
        display: none;
    }

    .center-logo-section {
        display: flex;
        justify-content: center;

        .logo {
            span {
                height: auto;
            }
        }
        svg {
            height: ${rem(96)};
            width: ${rem(104)};
        }

        @media (max-width: ${breakpoints.md}px) {
            display: none;
        }
    }

    .navigation {
        justify-content: flex-end;

        .need-help-container,
        a {
            @media (max-width: ${breakpoints.xs}px) {
                margin-left: ${rem(6)};
                height: auto;
            }

            color: ${({ theme }) => theme.colors.black};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};

            p {
                font-size: ${({ theme }) => theme.fontSizes.h4};
                line-height: 22px;
                color: ${({ theme }) => theme.colors.grey5};
                text-transform: capitalize;
                white-space: normal;
            }

            &.need-help-link {
                @media (max-width: ${breakpoints.xs}px) {
                    padding: 0;
                }

                .need-help-icon svg {
                    @media (max-width: ${breakpoints.xs}px) {
                        width: ${rem(24)};
                        height: ${rem(24)};
                    }

                    width: ${rem(32)};
                    height: ${rem(32)};
                }
            }
        }

        > a {
            @media (max-width: ${breakpoints.xs}px) {
                path {
                    fill: ${({ theme }) => theme.colors.grey1} !important;
                }
            }
        }

        svg {
            @media (max-width: ${breakpoints.xs}px) {
                width: ${rem(24)};
                height: ${rem(24)};
            }

            width: ${rem(32)};
            height: ${rem(32)};
        }

        .need-help-open {
            background: ${({ theme }) => theme.colors.white};
        }

        .logo {
            height: ${rem(80)};

            @media (min-width: ${breakpoints.md}px) {
                display: none;
            }

            svg {
                width: ${rem(60)};
                height: ${rem(80)};
            }
        }

        .header__nav-wrapper {
            margin-top: ${rem('3px')};
            display: block !important;
        }

        .header__nav-description,
        .header__nav-description_secondary {
            display: none !important;
            text-align: center;

            @media (min-width: ${breakpoints.md}px) {
                display: block !important;
            }

            &.needHelp {
                width: ${rem(150)};
            }
        }

        .header__nav-description_secondary {
            color: ${({ theme }) => theme.colors.grey5};
            text-align: center;
            margin-top: 0;
        }

        .header__nav-description_primary {
            color: ${({ theme }) => theme.colors.blue2};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            display: flex;
            align-items: center;
            white-space: nowrap;

            svg {
                width: ${rem(12)};
                height: ${rem(12)};
                margin: 0 0 -${rem(2)} ${rem(5)};

                path {
                    fill: ${({ theme }) => theme.colors.blue2};
                }
            }
        }

        .logoutBox .accountStatement:hover p {
            color: ${({ theme }) => theme.colors.primary};
        }

        .logoutBox .accountStatement:hover {
            p {
                color: ${({ theme }) => theme.colors.primary};
            }
        }

        .logoutBox {
            width: ${rem('214px')};

            &.without-account {
                .logoutButtonText {
                    position: relative;
                    bottom: 0;
                }
            }

            .accountStatement {
                &:hover {
                    p {
                        color: ${({ theme }) => theme.colors.red};
                    }
                }
            }

            .logoutButton {
                background: ${({ theme }) => theme.colors.blue2};
                border-radius: ${rem(24)};

                &:hover {
                    background: ${({ theme }) => theme.colors.grey5};
                    border: 1px solid ${({ theme }) => theme.colors.grey5};
                }

                p {
                    color: ${({ theme }) => theme.colors.white};
                }
            }
        }

        .need-help-section {
            top: ${rem(120)};

            @media (min-width: ${breakpoints.md}px) {
                top: ${rem(80)};
            }

            &__title {
                font-size: ${({ theme }) => theme.fontSizes.h2} !important;
            }

            &__link {
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            &__text {
                font-size: ${({ theme }) => theme.fontSizes.h5} !important;
            }
        }

        .need-help-link {
            padding-top: ${rem(3)} !important;
        }

        .need-help-link .icon-wrapper {
            margin-bottom: ${rem(4)};
        }

        .need-help-icon svg {
            margin-top: -${rem(4)};
        }

        .link-wrapper {
            @media (min-width: ${breakpoints.xs}px) {
                display: none !important;
            }
        }
    }

    .link-wrapper-b2c {
        svg {
            width: ${rem(17)};
            height: ${rem(19)};
            margin-right: ${rem(4)};
        }
    }

    .link-section {
        a {
            padding-bottom: ${rem('16px')};

            :hover {
                /* not specified in design */
                color: ${({ theme }) => theme.colors.primaryDisabled};
                border-bottom-color: ${({ theme }) => theme.colors.primaryDisabled};
            }
        }
    }
`;
